module.exports = __webpack_public_path__ + "img/excel.4ff92dc3.svg";